// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2ur8F","cell":"ColumnAccessor_cell__3ZtRC","firstCellAccent":"ColumnAccessor_firstCellAccent__osMhF"};